import {Component, EventEmitter, Input, Output} from '@angular/core';
export class PromptBodyComponent {

     modal: boolean = false;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'prompt-body',
    template: `
        <div [class.modal-body]="modal">
            <div [class.form-group]="!modal">
                <ng-content></ng-content>
            </div>
        </div>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'modal': [{ type: Input },],
};
}

function PromptBodyComponent_tsickle_Closure_declarations() {
/** @type {?} */
PromptBodyComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PromptBodyComponent.ctorParameters;
/** @type {?} */
PromptBodyComponent.propDecorators;
/** @type {?} */
PromptBodyComponent.prototype.modal;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
